import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppGateService } from '../../services/app-gate.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gate',
  templateUrl: './app-gate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppBannerComponent {
  public androidURL = environment.androidURL;
  public appleURL = environment.appleURL;

  constructor(
    public bannerService: AppGateService,
  ) { }

  getApp(): void {
    if (this.bannerService.isAndroid) {
      window.location.href = this.androidURL
    }
    if (this.bannerService.isIOS) {
      window.location.href = this.appleURL
    }
  }

  dismiss(): void {
    sessionStorage.setItem('hideAppBanner', 'true');
  }

  get isIos(): boolean {
    return this.bannerService.isIOS
  }

  get shouldShow(): boolean {
    return (
      this.bannerService.isMobile &&
      sessionStorage.getItem('hideAppBanner') !== 'true'
    );
  }
}